/**
 * useGetAffectedOrders Hook
 * Custom hook for fetching orders that will be affected by subscription cancellation
 */

import {useMutation} from 'react-query';
import {AffectedOrder} from '~types/subscription/subscription.types';
import {useUserStore} from '~providers/userStore/zustand';
import {BASE_API_URL} from '@env';

/**
 * Call the affected orders API
 */
async function getAffectedOrdersAPI(token?: string): Promise<AffectedOrder[]> {
  const headers: Record<string, string> = {
    'accept': 'application/json',
  };

  if (token) {
    headers['Authorization'] = `${token}`;
  }

  const response = await fetch(`${BASE_API_URL}orders/subscription-expired/orders`, {
    method: 'GET',
    headers,
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch affected orders: ${response.status}`);
  }

  const data: AffectedOrder[] = await response.json();
  return data;
}

export const useGetAffectedOrders = () => {
  return useMutation(
    async () => {
      const token = useUserStore.getState().token;
      return getAffectedOrdersAPI(token);
    }
  );
};
